import AudioRecorder from './Recorder.vue';
import AudioMixin from './audioHelpers/AudioMixin';
import RecorderMixin from './audioHelpers/RecorderMixin';
import AudioPlayerMixin from './audioHelpers/AudioPlayerMixin';
import subComponents from './components';

export default AudioRecorder;
export { AudioMixin, RecorderMixin, AudioPlayerMixin, subComponents };
